import React from 'react';
import { Image } from "@arctheme-components/elements/Image/Image";

const IconArrowRight = ({ size = 36, onClick, icon = '' }: any) => {
    const isImage = icon.includes('.') && (icon.endsWith('.png') || icon.endsWith('.jpg') || icon.endsWith('.jpeg') || icon.endsWith('.svg'));

    return (
        <div className={'navigation-arrow-right'} onClick={onClick} style={{ fontSize: size }}>
            {isImage ? (
                <Image imageUrl={icon} alt={'Navigation Arrow Right'} width={size} height={size} />
            ) : (
                <i className={`icon icon-${icon}`} />
            )}
        </div>
    );
};

export default IconArrowRight;
